import { render, staticRenderFns } from "./hr_employee.vue?vue&type=template&id=85e1e4a0&scoped=true"
import script from "./hr_employee.vue?vue&type=script&lang=js"
export * from "./hr_employee.vue?vue&type=script&lang=js"
import style0 from "./hr_employee.vue?vue&type=style&index=0&id=85e1e4a0&prod&scoped=true&lang=less"
import style1 from "./hr_employee.vue?vue&type=style&index=1&id=85e1e4a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e1e4a0",
  null
  
)

export default component.exports